import { useDispatch } from 'react-redux';
import { eventActions } from '../../../../store/modules/event';
import { appActions } from '../../../../store/modules/app';

const useEventAllListUtils = (allEvent) => {
  const dispatch = useDispatch();

  const setData = (args) => {
    return dispatch(eventActions.setData(args));
  };

  /**
   * 전체 기획전 초기화 하기
   */
  const setInitialAllEventList = () => {
    const { originalAllEventList } = allEvent;
    setData({
      path: ['allEvent', 'allEventList', 'list'],
      value: originalAllEventList,
    });
  };

  const openEventItemListModal = (data) => {
    dispatch(appActions.openEventItemListModal(data));
  };

  return {
    setData,
    setInitialAllEventList,
    openEventItemListModal,
  };
};

export default useEventAllListUtils;
